export const translations = {
  pt: {
    // Landing
    platform_for: "PLATAFORMA PARA PROFISSIONAIS DA ESTÉTICA",
    hero_title: "Sua evolução profissional",
    hero_title_italic: "",
    hero_title_end: "começa aqui.",
    hero_description: "Estude com mais confiança, organize seus atendimentos e tenha as ferramentas essenciais da sua rotina em um só lugar.",
    create_account_free: "CRIAR MINHA CONTA",
    already_have_account: "JÁ TENHO CONTA",
    active_members: "Membros ativos",
    features: "Funcionalidades",
    everything_you_need: "Tudo o que você precisa em um só lugar",
    ready_to_start: "Seu próximo passo começa aqui.",
    join_hundreds: "Transforme sua rotina de estudos e atendimentos com uma plataforma pensada para profissionais da estética.",
    create_my_account: "CRIAR MINHA CONTA",
    
    // Emotional Section
    emotional_title: "Mais organização. Mais confiança. Mais profissionalismo.",
    emotional_description: "A AESTHA foi criada para acompanhar a rotina de quem estuda e trabalha com estética, reunindo conhecimento e ferramentas de gestão em uma experiência simples, prática e intuitiva.",
    
    // Features
    feature_exams_title: "Estudos e Simulados",
    feature_exams_desc: "Prepare-se para suas provas com conteúdos organizados, simulados e acompanhamento do seu desempenho.",
    feature_anamnesis_title: "Anamnese Digital",
    feature_anamnesis_desc: "Organize avaliações e informações dos seus clientes em fichas digitais.",
    feature_clients_title: "Gestão de Clientes",
    feature_clients_desc: "Centralize cadastros, histórico de atendimentos e registros profissionais.",
    feature_mobile_title: "Consentimento e Evolução",
    feature_mobile_desc: "Registre termos assinados e acompanhe a evolução dos atendimentos com fotografias.",
    
    // Mobile compatibility text
    mobile_compatibility: "Acesse pelo celular, tablet ou computador.",
    
    // Auth
    login: "Entrar",
    register: "Começar",
    welcome_back: "Bem-vinda de volta",
    enter_account: "Entre na sua conta para continuar sua jornada profissional.",
    email: "Email",
    password: "Senha",
    confirm_password: "Confirmar senha",
    full_name: "Nome completo",
    create_account: "Criar conta",
    fill_data: "Preencha seus dados para começar",
    no_account: "Não tem uma conta?",
    have_account: "Já tem uma conta?",
    min_characters: "Mínimo 6 caracteres",
    wait_activation: "Após criar sua conta, aguarde a ativação pela administração.",
    back: "Voltar",
    logging_in: "Entrando...",
    creating_account: "Criando conta...",
    
    // Dashboard
    dashboard: "Dashboard",
    hello: "Olá",
    welcome_to_aesthahub: "Bem-vinda ao AESTHAHUB",
    welcome_description: "Sua plataforma profissional para organizar seus atendimentos, gerenciar fichas e termos com segurança e praticar simulados para suas provas.",
    welcome_features_title: "Aqui você pode:",
    welcome_feature_1: "Realizar simulados por conteúdo",
    welcome_feature_2: "Acompanhar seu desempenho",
    welcome_feature_3: "Organizar seus clientes",
    welcome_feature_4: "Utilizar fichas e termos profissionais",
    welcome_feature_5: "Registrar evolução com fotos",
    welcome_footer: "Tudo em um só lugar, de forma simples e profissional.",
    exams_completed: "Simulados realizados",
    average_score: "Média geral",
    registered_clients: "Clientes cadastrados",
    exams: "Seus simulados",
    practice_exams: "Pratique para suas provas",
    clients: "Seus clientes",
    manage_records: "Gerencie fichas e termos",
    recent_activity: "Atividade Recente",
    see_all: "Ver tudo",
    no_activity: "Nenhuma atividade ainda",
    start_exam_or_client: "Suas atividades aparecerão aqui conforme você utilizar a plataforma.",
    loading: "Carregando...",
    
    // Exams
    questions: "questões",
    minutes: "min",
    no_exams_available: "Nenhum simulado disponível",
    no_exams_empty_message: "Não há simulados disponíveis para o seu acesso no momento.",
    wait_new_exams: "Aguarde novos simulados serem adicionados pela administração.",
    question: "Questão",
    of: "de",
    previous: "Anterior",
    next: "Próxima",
    answered: "respondidas",
    finish: "Finalizar",
    finish_exam: "Finalizar simulado?",
    you_answered: "Você respondeu",
    unanswered_questions: "Existem questões não respondidas!",
    confirm: "Confirmar",
    exit: "Sair",
    
    // Results
    you_got: "Você acertou",
    of_questions: "de",
    see_answers: "Ver respostas",
    hide_answers: "Ocultar respostas",
    redo: "Refazer",
    back_to_dashboard: "Voltar ao Dashboard",
    explanation: "Explicação",
    
    // History
    history: "Seu histórico",
    your_exams: "Seus simulados",
    total_completed: "Total realizados",
    general_average: "Média geral",
    best_score: "Melhor nota",
    no_exams_done: "Nenhum simulado realizado",
    no_history_message: "Você ainda não realizou nenhum simulado. Comece agora para acompanhar seu progresso.",
    do_first_exam: "Faça seu primeiro simulado para ver seu histórico aqui.",
    see_exams: "Ver simulados",
    correct_answers: "acertos",
    
    // Clients
    your_clients: "Seus clientes",
    new_client: "Adicionar cliente",
    search_placeholder: "Buscar por nome, email ou telefone...",
    no_clients: "Nenhum cliente cadastrado",
    no_clients_message: "Você ainda não cadastrou clientes. Adicione seu primeiro cliente para começar a organizar seus atendimentos.",
    add_first_client: "Adicione seu primeiro cliente para começar.",
    no_client_found: "Nenhum cliente encontrado",
    try_another_search: "Tente buscar por outro termo.",
    register_client: "Cadastrar cliente",
    personal_data: "Dados Pessoais",
    full_name_required: "Nome completo *",
    client_name: "Nome do cliente",
    phone: "Telefone",
    birth_date: "Data de nascimento",
    observations: "Observações",
    general_notes: "Anotações gerais sobre o cliente...",
    cancel: "Cancelar",
    save: "Cadastrar",
    saving: "Salvando...",
    client_since: "Cliente desde",
    edit: "Editar",
    delete: "Excluir",
    delete_client: "Excluir cliente?",
    delete_client_warning: "Esta ação não pode ser desfeita. Todas as fichas de anamnese e termos de consentimento serão excluídos.",
    
    // Anamnesis & Consent
    anamnesis_records: "Fichas de Anamnese",
    consent_terms: "Termos de Consentimento",
    new_record: "Criar ficha",
    new_term: "Criar termo",
    select_template: "Selecione o modelo",
    change_template: "Trocar modelo",
    save_record: "Salvar Ficha",
    no_records: "Nenhuma ficha criada ainda",
    no_records_message: "Nenhuma ficha criada ainda. Crie sua primeira ficha para manter seus registros profissionais organizados.",
    create_anamnesis: "Crie uma ficha de anamnese para este cliente.",
    select_term: "Selecione o termo",
    change_term: "Trocar termo",
    confirm_signature: "Confirmar Assinatura",
    signature_note: "Ao clicar em confirmar, você registra que o cliente leu e concordou com este termo.",
    no_terms: "Nenhum termo registrado ainda",
    no_terms_message: "Nenhum termo registrado ainda. Crie um termo para coletar assinaturas com mais segurança.",
    register_terms: "Registre termos de consentimento assinados pelo cliente.",
    signed: "Assinado",
    signed_on: "Assinado em",
    fields: "campos",
    view_record: "Visualizar",
    
    // Admin
    admin_panel: "Painel Administrativo",
    overview: "Visão Geral",
    registered_users: "Usuários cadastrados",
    active: "ativos",
    created_exams: "Simulados criados",
    templates: "Templates",
    quick_actions: "Ações Rápidas",
    manage_users: "Gerenciar Usuários",
    new_exam: "Novo Simulado",
    edit_templates: "Editar Templates",
    see_exams_admin: "Ver Simulados",
    administration: "Administração",
    users: "Usuários",
    active_of: "ativos de",
    activate: "Ativar",
    deactivate: "Desativar",
    pending: "Pendente",
    delete_user: "Excluir usuário?",
    delete_user_warning: "Esta ação não pode ser desfeita. O usuário",
    will_be_deleted: "será permanentemente excluído.",
    
    // Exam Admin
    create_exam: "Criar simulado",
    edit_exam: "Editar simulado",
    basic_info: "Informações Básicas",
    title: "Título",
    title_placeholder: "Ex: Simulado de Estética Facial",
    description: "Descrição",
    description_placeholder: "Descrição opcional do simulado...",
    time_limit: "Tempo limite (minutos)",
    time_placeholder: "Ex: 60",
    no_time_limit: "Deixe vazio para sem limite de tempo",
    add_question: "Adicionar Questão",
    statement: "Enunciado *",
    type_question: "Digite a pergunta...",
    options: "Opções",
    option: "Opção",
    add_option: "Adicionar opção",
    mark_correct: "Marque a caixa da opção correta",
    explanation_optional: "Explicação (opcional)",
    explanation_placeholder: "Explicação exibida após responder...",
    create_exam_btn: "Criar Simulado",
    save_changes: "Salvar Alterações",
    delete_exam: "Excluir simulado?",
    delete_exam_warning: "Esta ação não pode ser desfeita. O simulado",
    disabled: "Desativado",
    
    // Templates Admin
    anamnesis_models: "Modelos de Anamnese",
    new_model: "Novo Modelo",
    edit_model: "Editar Modelo",
    new_anamnesis_model: "Novo Modelo de Anamnese",
    model_name: "Nome *",
    model_name_placeholder: "Ex: Ficha Facial Completa",
    add: "Adicionar",
    field: "Campo",
    field_name: "Nome do campo",
    short_text: "Texto curto",
    long_text: "Texto longo",
    selection: "Seleção",
    checkbox: "Checkbox",
    options_comma: "Opções (separadas por vírgula)",
    options_placeholder: "Opção 1, Opção 2, Opção 3",
    no_fields: "Nenhum campo adicionado. Clique em \"Adicionar\" para criar campos.",
    create_model: "Criar Modelo",
    no_model_created: "Nenhum modelo criado",
    consent_terms_admin: "Termos de Consentimento",
    new_consent_term: "Novo Termo de Consentimento",
    edit_term: "Editar Termo",
    term_content: "Conteúdo do Termo *",
    term_content_placeholder: "Digite o texto completo do termo de consentimento...",
    create_term: "Criar Termo",
    no_term_created: "Nenhum termo criado",
    delete_template: "Excluir template?",
    delete_template_warning: "Esta ação não pode ser desfeita. O template",
    characters: "caracteres",
    
    // Users Admin
    registration: "Cadastro",
    actions: "Ações",
    no_users: "Nenhum usuário cadastrado",
    
    // Study Materials
    study_materials: "Materiais de Estudo",
    materials: "Seus materiais",
    categories: "Categorias",
    new_category: "Nova Categoria",
    new_material: "Novo Material",
    category_name: "Nome da categoria",
    category_description: "Descrição da categoria",
    material_title: "Título do material",
    material_description: "Descrição do material",
    select_category: "Selecione uma categoria",
    select_pdf: "Selecionar PDF",
    upload_pdf: "Enviar PDF",
    no_categories: "Nenhuma categoria criada",
    create_first_category: "Crie uma categoria primeiro para organizar seus materiais.",
    no_materials: "Nenhum material disponível",
    no_materials_message: "Ainda não há materiais de estudo disponíveis. Aguarde novos conteúdos serem adicionados.",
    no_materials_in_category: "Nenhum material nesta categoria",
    view_material: "Visualizar",
    all_categories: "Todas as categorias",
    file_size: "Tamanho",
    questions_per_attempt: "Questões por tentativa",
    questions_per_attempt_hint: "Deixe vazio para usar todas as questões",
    of_total: "de",
    questions_in_bank: "no banco",
    create: "Criar",
    
    // Evolution Photos
    evolution: "Evolução",
    evolution_photos: "Fotos de Evolução",
    new_photo: "Adicionar foto",
    add_photo: "Adicionar Foto",
    photo_notes: "Anotações",
    photo_notes_placeholder: "Observações sobre esta foto...",
    no_photos: "Nenhuma foto registrada",
    no_photos_message: "Nenhuma foto de evolução registrada ainda. Adicione a primeira foto para acompanhar o progresso do cliente.",
    add_first_photo: "Adicione a primeira foto para acompanhar a evolução.",
    select_image: "Selecionar Imagem",
    upload_image: "Enviar Imagem",
    view_photo: "Visualizar",
    delete_photo: "Excluir foto",
    photo_added: "Foto adicionada!",
    photo_deleted: "Foto excluída!",
    confirm_delete_photo: "Tem certeza que deseja excluir esta foto?",
    
    // Template Categories
    template_categories: "Categorias de Templates",
    new_template_category: "Nova Categoria",
    template_category_name: "Nome da categoria",
    no_template_categories: "Nenhuma categoria criada",
    uncategorized: "Sem categoria",
    select_template_category: "Selecione uma categoria",
    
    // Subscription Plans
    plan: "Plano",
    select_plan: "Selecionar Plano",
    select_plan_for: "Escolha o plano de assinatura para",
    change_plan: "Alterar plano",
    plan_base: "Base",
    plan_advanced: "Avançado",
    plan_complete: "Completo",
    plan_base_desc: "Materiais de estudo e simulados",
    plan_advanced_desc: "Gestão de clientes",
    plan_complete_desc: "Acesso total",
    
    // Account
    pending_account: "Conta Pendente",
    pending_account_message: "Sua conta ainda não foi ativada. Entre em contato com a administração para liberar seu acesso.",
    back_to_home: "Voltar ao Início",
    logout: "Sair",
  },
  
  en: {
    // Landing
    platform_for: "Platform for Estheticians",
    hero_title: "Elevate your",
    hero_title_italic: "practice",
    hero_title_end: "to the next level",
    hero_description: "Practice exams and professional management of anamnesis forms and consent terms.",
    create_account_free: "Create Free Account",
    already_have_account: "I already have an account",
    active_members: "Active members",
    features: "Features",
    everything_you_need: "Everything you need",
    ready_to_start: "Ready to start?",
    join_hundreds: "Join hundreds of professionals who are already elevating their practice with AESTHA.",
    create_my_account: "Create My Account",
    
    // Features
    feature_exams_title: "Practice Exams",
    feature_exams_desc: "Prepare for your exams with complete simulations and instant feedback.",
    feature_anamnesis_title: "Anamnesis Forms",
    feature_anamnesis_desc: "Professional templates for complete client assessment.",
    feature_clients_title: "Client Management",
    feature_clients_desc: "Organize forms and consent terms by client.",
    feature_mobile_title: "100% Mobile",
    feature_mobile_desc: "Access everything from your phone or tablet, anywhere.",
    
    // Auth
    login: "Login",
    register: "Start",
    welcome_back: "Welcome back",
    enter_account: "Sign in to your account to continue",
    email: "Email",
    password: "Password",
    confirm_password: "Confirm password",
    full_name: "Full name",
    create_account: "Create account",
    fill_data: "Fill in your details to get started",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    min_characters: "Minimum 6 characters",
    wait_activation: "After creating your account, wait for activation by administration.",
    back: "Back",
    logging_in: "Logging in...",
    creating_account: "Creating account...",
    
    // Dashboard
    dashboard: "Dashboard",
    hello: "Hello",
    exams_completed: "Exams completed",
    average_score: "Average score",
    registered_clients: "Registered clients",
    exams: "Exams",
    practice_exams: "Practice for your exams",
    clients: "Clients",
    manage_records: "Manage forms and terms",
    recent_activity: "Recent Activity",
    see_all: "See all",
    no_activity: "No activity",
    start_exam_or_client: "Start by taking an exam or registering a client.",
    loading: "Loading...",
    
    // Exams
    questions: "questions",
    minutes: "min",
    no_exams_available: "No exams available",
    wait_new_exams: "Wait for new exams to be added by administration.",
    question: "Question",
    of: "of",
    previous: "Previous",
    next: "Next",
    answered: "answered",
    finish: "Finish",
    finish_exam: "Finish exam?",
    you_answered: "You answered",
    unanswered_questions: "There are unanswered questions!",
    confirm: "Confirm",
    exit: "Exit",
    
    // Results
    you_got: "You got",
    of_questions: "of",
    see_answers: "See answers",
    hide_answers: "Hide answers",
    redo: "Redo",
    back_to_dashboard: "Back to Dashboard",
    explanation: "Explanation",
    
    // History
    history: "History",
    your_exams: "Your exams",
    total_completed: "Total completed",
    general_average: "General average",
    best_score: "Best score",
    no_exams_done: "No exams completed",
    do_first_exam: "Take your first exam to see your history here.",
    see_exams: "See exams",
    correct_answers: "correct",
    
    // Clients
    your_clients: "Your clients",
    new_client: "New Client",
    search_placeholder: "Search by name, email or phone...",
    no_clients: "No registered clients",
    add_first_client: "Add your first client to get started.",
    no_client_found: "No client found",
    try_another_search: "Try searching for another term.",
    register_client: "Register client",
    personal_data: "Personal Data",
    full_name_required: "Full name *",
    client_name: "Client name",
    phone: "Phone",
    birth_date: "Birth date",
    observations: "Observations",
    general_notes: "General notes about the client...",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
    client_since: "Client since",
    edit: "Edit",
    delete: "Delete",
    delete_client: "Delete client?",
    delete_client_warning: "This action cannot be undone. All anamnesis forms and consent terms will be deleted.",
    
    // Anamnesis & Consent
    anamnesis_records: "Anamnesis Forms",
    consent_terms: "Consent Terms",
    new_record: "New Form",
    new_term: "New Term",
    select_template: "Select template",
    change_template: "Change template",
    save_record: "Save Form",
    no_records: "No forms registered",
    create_anamnesis: "Create an anamnesis form for this client.",
    select_term: "Select term",
    change_term: "Change term",
    confirm_signature: "Confirm Signature",
    signature_note: "By clicking confirm, you register that the client has read and agreed to this term.",
    no_terms: "No terms registered",
    register_terms: "Register consent terms signed by the client.",
    signed: "Signed",
    signed_on: "Signed on",
    fields: "fields",
    
    // Admin
    admin_panel: "Admin Panel",
    overview: "Overview",
    registered_users: "Registered users",
    active: "active",
    created_exams: "Created exams",
    templates: "Templates",
    quick_actions: "Quick Actions",
    manage_users: "Manage Users",
    new_exam: "New Exam",
    edit_templates: "Edit Templates",
    see_exams_admin: "See Exams",
    administration: "Administration",
    users: "Users",
    active_of: "active of",
    activate: "Activate",
    deactivate: "Deactivate",
    pending: "Pending",
    delete_user: "Delete user?",
    delete_user_warning: "This action cannot be undone. The user",
    will_be_deleted: "will be permanently deleted.",
    
    // Exam Admin
    create_exam: "Create exam",
    edit_exam: "Edit exam",
    basic_info: "Basic Information",
    title: "Title",
    title_placeholder: "E.g.: Facial Aesthetics Exam",
    description: "Description",
    description_placeholder: "Optional exam description...",
    time_limit: "Time limit (minutes)",
    time_placeholder: "E.g.: 60",
    no_time_limit: "Leave empty for no time limit",
    add_question: "Add Question",
    statement: "Statement *",
    type_question: "Type the question...",
    options: "Options",
    option: "Option",
    add_option: "Add option",
    mark_correct: "Check the correct option",
    explanation_optional: "Explanation (optional)",
    explanation_placeholder: "Explanation shown after answering...",
    create_exam_btn: "Create Exam",
    save_changes: "Save Changes",
    delete_exam: "Delete exam?",
    delete_exam_warning: "This action cannot be undone. The exam",
    disabled: "Disabled",
    
    // Templates Admin
    anamnesis_models: "Anamnesis Models",
    new_model: "New Model",
    edit_model: "Edit Model",
    new_anamnesis_model: "New Anamnesis Model",
    model_name: "Name *",
    model_name_placeholder: "E.g.: Complete Facial Form",
    add: "Add",
    field: "Field",
    field_name: "Field name",
    short_text: "Short text",
    long_text: "Long text",
    selection: "Selection",
    checkbox: "Checkbox",
    options_comma: "Options (comma separated)",
    options_placeholder: "Option 1, Option 2, Option 3",
    no_fields: "No fields added. Click \"Add\" to create fields.",
    create_model: "Create Model",
    no_model_created: "No model created",
    consent_terms_admin: "Consent Terms",
    new_consent_term: "New Consent Term",
    edit_term: "Edit Term",
    term_content: "Term Content *",
    term_content_placeholder: "Enter the full consent term text...",
    create_term: "Create Term",
    no_term_created: "No term created",
    delete_template: "Delete template?",
    delete_template_warning: "This action cannot be undone. The template",
    characters: "characters",
    
    // Users Admin
    registration: "Registration",
    actions: "Actions",
    no_users: "No users registered",
    
    // Account
    pending_account: "Pending Account",
    pending_account_message: "Your account has not been activated yet. Contact administration to enable your access.",
    back_to_home: "Back to Home",
    logout: "Logout",
    
    // Study Materials
    study_materials: "Study Materials",
    materials: "Materials",
    categories: "Categories",
    new_category: "New Category",
    new_material: "New Material",
    category_name: "Category name",
    category_description: "Category description",
    material_title: "Material title",
    material_description: "Material description",
    select_category: "Select a category",
    select_pdf: "Select PDF",
    upload_pdf: "Upload PDF",
    no_categories: "No categories created",
    create_first_category: "Create a category first to organize your materials.",
    no_materials: "No materials available",
    no_materials_in_category: "No materials in this category",
    view_material: "View material",
    all_categories: "All categories",
    file_size: "Size",
    questions_per_attempt: "Questions per attempt",
    questions_per_attempt_hint: "Leave empty to use all questions",
    of_total: "of",
    questions_in_bank: "in bank",
    create: "Create",
    
    // Evolution Photos
    evolution: "Evolution",
    evolution_photos: "Evolution Photos",
    new_photo: "New Photo",
    add_photo: "Add Photo",
    photo_notes: "Notes",
    photo_notes_placeholder: "Observations about this photo...",
    no_photos: "No photos recorded",
    add_first_photo: "Add the first photo to track evolution.",
    select_image: "Select Image",
    upload_image: "Upload Image",
    view_photo: "View photo",
    delete_photo: "Delete photo",
    photo_added: "Photo added!",
    photo_deleted: "Photo deleted!",
    confirm_delete_photo: "Are you sure you want to delete this photo?",
    
    // Template Categories
    template_categories: "Template Categories",
    new_template_category: "New Category",
    template_category_name: "Category name",
    no_template_categories: "No categories created",
    uncategorized: "Uncategorized",
    select_template_category: "Select a category",
    
    // Subscription Plans
    plan: "Plan",
    select_plan: "Select Plan",
    select_plan_for: "Choose the subscription plan for",
    change_plan: "Change plan",
    plan_base: "Base",
    plan_advanced: "Advanced",
    plan_complete: "Complete",
    plan_base_desc: "Study materials and exams",
    plan_advanced_desc: "Client management",
    plan_complete_desc: "Full access",
  },
  
  es: {
    // Landing
    platform_for: "Plataforma para Esteticistas",
    hero_title: "Eleva tu",
    hero_title_italic: "práctica",
    hero_title_end: "al siguiente nivel",
    hero_description: "Simulacros para tus exámenes y gestión profesional de fichas de anamnesis y términos de consentimiento.",
    create_account_free: "Crear Cuenta Gratis",
    already_have_account: "Ya tengo cuenta",
    active_members: "Miembros activos",
    features: "Funcionalidades",
    everything_you_need: "Todo lo que necesitas",
    ready_to_start: "¿Lista para empezar?",
    join_hundreds: "Únete a cientos de profesionales que ya están elevando su práctica con AESTHA.",
    create_my_account: "Crear Mi Cuenta",
    
    // Features
    feature_exams_title: "Simulacros de Exámenes",
    feature_exams_desc: "Prepárate para tus exámenes con simulacros completos y retroalimentación instantánea.",
    feature_anamnesis_title: "Fichas de Anamnesis",
    feature_anamnesis_desc: "Plantillas profesionales para evaluación completa de tus clientes.",
    feature_clients_title: "Gestión de Clientes",
    feature_clients_desc: "Organiza fichas y términos de consentimiento por cliente.",
    feature_mobile_title: "100% Móvil",
    feature_mobile_desc: "Accede a todo desde tu celular o tablet, donde estés.",
    
    // Auth
    login: "Entrar",
    register: "Comenzar",
    welcome_back: "Bienvenida de vuelta",
    enter_account: "Inicia sesión en tu cuenta para continuar",
    email: "Correo electrónico",
    password: "Contraseña",
    confirm_password: "Confirmar contraseña",
    full_name: "Nombre completo",
    create_account: "Crear cuenta",
    fill_data: "Completa tus datos para comenzar",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    min_characters: "Mínimo 6 caracteres",
    wait_activation: "Después de crear tu cuenta, espera la activación por parte de la administración.",
    back: "Volver",
    logging_in: "Iniciando sesión...",
    creating_account: "Creando cuenta...",
    
    // Dashboard
    dashboard: "Panel",
    hello: "Hola",
    exams_completed: "Simulacros realizados",
    average_score: "Promedio general",
    registered_clients: "Clientes registrados",
    exams: "Simulacros",
    practice_exams: "Practica para tus exámenes",
    clients: "Clientes",
    manage_records: "Gestiona fichas y términos",
    recent_activity: "Actividad Reciente",
    see_all: "Ver todo",
    no_activity: "Sin actividad",
    start_exam_or_client: "Comienza haciendo un simulacro o registrando un cliente.",
    loading: "Cargando...",
    
    // Exams
    questions: "preguntas",
    minutes: "min",
    no_exams_available: "No hay simulacros disponibles",
    wait_new_exams: "Espera a que la administración agregue nuevos simulacros.",
    question: "Pregunta",
    of: "de",
    previous: "Anterior",
    next: "Siguiente",
    answered: "respondidas",
    finish: "Finalizar",
    finish_exam: "¿Finalizar simulacro?",
    you_answered: "Respondiste",
    unanswered_questions: "¡Hay preguntas sin responder!",
    confirm: "Confirmar",
    exit: "Salir",
    
    // Results
    you_got: "Acertaste",
    of_questions: "de",
    see_answers: "Ver respuestas",
    hide_answers: "Ocultar respuestas",
    redo: "Repetir",
    back_to_dashboard: "Volver al Panel",
    explanation: "Explicación",
    
    // History
    history: "Historial",
    your_exams: "Tus simulacros",
    total_completed: "Total realizados",
    general_average: "Promedio general",
    best_score: "Mejor nota",
    no_exams_done: "Ningún simulacro realizado",
    do_first_exam: "Haz tu primer simulacro para ver tu historial aquí.",
    see_exams: "Ver simulacros",
    correct_answers: "aciertos",
    
    // Clients
    your_clients: "Tus clientes",
    new_client: "Nuevo Cliente",
    search_placeholder: "Buscar por nombre, correo o teléfono...",
    no_clients: "Ningún cliente registrado",
    add_first_client: "Agrega tu primer cliente para comenzar.",
    no_client_found: "Ningún cliente encontrado",
    try_another_search: "Intenta buscar otro término.",
    register_client: "Registrar cliente",
    personal_data: "Datos Personales",
    full_name_required: "Nombre completo *",
    client_name: "Nombre del cliente",
    phone: "Teléfono",
    birth_date: "Fecha de nacimiento",
    observations: "Observaciones",
    general_notes: "Notas generales sobre el cliente...",
    cancel: "Cancelar",
    save: "Guardar",
    saving: "Guardando...",
    client_since: "Cliente desde",
    edit: "Editar",
    delete: "Eliminar",
    delete_client: "¿Eliminar cliente?",
    delete_client_warning: "Esta acción no se puede deshacer. Se eliminarán todas las fichas de anamnesis y términos de consentimiento.",
    
    // Anamnesis & Consent
    anamnesis_records: "Fichas de Anamnesis",
    consent_terms: "Términos de Consentimiento",
    new_record: "Nueva Ficha",
    new_term: "Nuevo Término",
    select_template: "Selecciona la plantilla",
    change_template: "Cambiar plantilla",
    save_record: "Guardar Ficha",
    no_records: "Ninguna ficha registrada",
    create_anamnesis: "Crea una ficha de anamnesis para este cliente.",
    select_term: "Selecciona el término",
    change_term: "Cambiar término",
    confirm_signature: "Confirmar Firma",
    signature_note: "Al hacer clic en confirmar, registras que el cliente leyó y aceptó este término.",
    no_terms: "Ningún término registrado",
    register_terms: "Registra términos de consentimiento firmados por el cliente.",
    signed: "Firmado",
    signed_on: "Firmado el",
    fields: "campos",
    
    // Admin
    admin_panel: "Panel Administrativo",
    overview: "Visión General",
    registered_users: "Usuarios registrados",
    active: "activos",
    created_exams: "Simulacros creados",
    templates: "Plantillas",
    quick_actions: "Acciones Rápidas",
    manage_users: "Gestionar Usuarios",
    new_exam: "Nuevo Simulacro",
    edit_templates: "Editar Plantillas",
    see_exams_admin: "Ver Simulacros",
    administration: "Administración",
    users: "Usuarios",
    active_of: "activos de",
    activate: "Activar",
    deactivate: "Desactivar",
    pending: "Pendiente",
    delete_user: "¿Eliminar usuario?",
    delete_user_warning: "Esta acción no se puede deshacer. El usuario",
    will_be_deleted: "será eliminado permanentemente.",
    
    // Exam Admin
    create_exam: "Crear simulacro",
    edit_exam: "Editar simulacro",
    basic_info: "Información Básica",
    title: "Título",
    title_placeholder: "Ej: Simulacro de Estética Facial",
    description: "Descripción",
    description_placeholder: "Descripción opcional del simulacro...",
    time_limit: "Límite de tiempo (minutos)",
    time_placeholder: "Ej: 60",
    no_time_limit: "Deja vacío para sin límite de tiempo",
    add_question: "Agregar Pregunta",
    statement: "Enunciado *",
    type_question: "Escribe la pregunta...",
    options: "Opciones",
    option: "Opción",
    add_option: "Agregar opción",
    mark_correct: "Marca la opción correcta",
    explanation_optional: "Explicación (opcional)",
    explanation_placeholder: "Explicación mostrada después de responder...",
    create_exam_btn: "Crear Simulacro",
    save_changes: "Guardar Cambios",
    delete_exam: "¿Eliminar simulacro?",
    delete_exam_warning: "Esta acción no se puede deshacer. El simulacro",
    disabled: "Desactivado",
    
    // Templates Admin
    anamnesis_models: "Modelos de Anamnesis",
    new_model: "Nuevo Modelo",
    edit_model: "Editar Modelo",
    new_anamnesis_model: "Nuevo Modelo de Anamnesis",
    model_name: "Nombre *",
    model_name_placeholder: "Ej: Ficha Facial Completa",
    add: "Agregar",
    field: "Campo",
    field_name: "Nombre del campo",
    short_text: "Texto corto",
    long_text: "Texto largo",
    selection: "Selección",
    checkbox: "Casilla",
    options_comma: "Opciones (separadas por coma)",
    options_placeholder: "Opción 1, Opción 2, Opción 3",
    no_fields: "Ningún campo agregado. Haz clic en \"Agregar\" para crear campos.",
    create_model: "Crear Modelo",
    no_model_created: "Ningún modelo creado",
    consent_terms_admin: "Términos de Consentimiento",
    new_consent_term: "Nuevo Término de Consentimiento",
    edit_term: "Editar Término",
    term_content: "Contenido del Término *",
    term_content_placeholder: "Escribe el texto completo del término de consentimiento...",
    create_term: "Crear Término",
    no_term_created: "Ningún término creado",
    delete_template: "¿Eliminar plantilla?",
    delete_template_warning: "Esta acción no se puede deshacer. La plantilla",
    characters: "caracteres",
    
    // Users Admin
    registration: "Registro",
    actions: "Acciones",
    no_users: "Ningún usuario registrado",
    
    // Account
    pending_account: "Cuenta Pendiente",
    pending_account_message: "Tu cuenta aún no ha sido activada. Contacta a la administración para habilitar tu acceso.",
    back_to_home: "Volver al Inicio",
    logout: "Salir",
    
    // Study Materials
    study_materials: "Materiales de Estudio",
    materials: "Materiales",
    categories: "Categorías",
    new_category: "Nueva Categoría",
    new_material: "Nuevo Material",
    category_name: "Nombre de la categoría",
    category_description: "Descripción de la categoría",
    material_title: "Título del material",
    material_description: "Descripción del material",
    select_category: "Selecciona una categoría",
    select_pdf: "Seleccionar PDF",
    upload_pdf: "Subir PDF",
    no_categories: "Ninguna categoría creada",
    create_first_category: "Crea una categoría primero para organizar tus materiales.",
    no_materials: "Ningún material disponible",
    no_materials_in_category: "Ningún material en esta categoría",
    view_material: "Ver material",
    all_categories: "Todas las categorías",
    file_size: "Tamaño",
    questions_per_attempt: "Preguntas por intento",
    questions_per_attempt_hint: "Deja vacío para usar todas las preguntas",
    of_total: "de",
    questions_in_bank: "en el banco",
    create: "Crear",
    
    // Evolution Photos
    evolution: "Evolución",
    evolution_photos: "Fotos de Evolución",
    new_photo: "Nueva Foto",
    add_photo: "Agregar Foto",
    photo_notes: "Notas",
    photo_notes_placeholder: "Observaciones sobre esta foto...",
    no_photos: "Ninguna foto registrada",
    add_first_photo: "Agrega la primera foto para seguir la evolución.",
    select_image: "Seleccionar Imagen",
    upload_image: "Subir Imagen",
    view_photo: "Ver foto",
    delete_photo: "Eliminar foto",
    photo_added: "¡Foto agregada!",
    photo_deleted: "¡Foto eliminada!",
    confirm_delete_photo: "¿Estás seguro de que deseas eliminar esta foto?",
    
    // Template Categories
    template_categories: "Categorías de Plantillas",
    new_template_category: "Nueva Categoría",
    template_category_name: "Nombre de la categoría",
    no_template_categories: "Ninguna categoría creada",
    uncategorized: "Sin categoría",
    select_template_category: "Selecciona una categoría",
    
    // Subscription Plans
    plan: "Plan",
    select_plan: "Seleccionar Plan",
    select_plan_for: "Elige el plan de suscripción para",
    change_plan: "Cambiar plan",
    plan_base: "Base",
    plan_advanced: "Avanzado",
    plan_complete: "Completo",
    plan_base_desc: "Materiales de estudio y simulacros",
    plan_advanced_desc: "Gestión de clientes",
    plan_complete_desc: "Acceso completo",
  }
};
